const updates = [
  { date: '2026-07-31', title: '《星际征途3》高清版已上线', tag: '新片上线' },
  { date: '2026-07-30', title: '暑期档观影指南专题页面发布', tag: '专题更新' },
  { date: '2026-07-29', title: '播放线路优化升级，加载速度提升40%', tag: '系统升级' },
  { date: '2026-07-28', title: '《大明风云录》全集更新完成', tag: '剧集完结' },
  { date: '2026-07-27', title: '移动客户端v3.2.0版本发布', tag: '版本更新' },
  { date: '2026-07-26', title: '新增纪录片分类频道上线', tag: '频道新增' },
  { date: '2026-07-25', title: '《暗夜追踪》导演剪辑版独家上线', tag: '独家资源' },
  { date: '2026-07-24', title: '日漫秋季新番专题页上线', tag: '专题更新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          最新动态
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">平台更新与影视快讯</p>

        <div className="mt-10 relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((update, idx) => (
              <div key={idx} className="relative flex items-start gap-5 md:gap-6 pl-10 md:pl-12">
                <div className={`absolute left-[11px] md:left-[14px] w-2.5 h-2.5 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>

                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-foreground-400">{update.date}</span>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
                      update.tag === '新片上线' ? 'bg-accent-100 text-accent-700' :
                      update.tag === '系统升级' ? 'bg-secondary-100 text-secondary-700' :
                      update.tag === '独家资源' ? 'bg-primary-100 text-primary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {update.tag}
                    </span>
                  </div>
                  <p className="mt-2 text-sm font-medium text-foreground-800">{update.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}